/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./LandingPage.css";

import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useAssessment } from "../self-assesment/AssessmentContext.js";
import { BrowserBlockScreen } from "../self-assesment/SelfAssesment.jsx";
import { Header } from "./Header.jsx";
import { Footer } from "./Footer.jsx";
import { StartMyra } from "./StartMyra.jsx";
import { LandingPageModal } from "../self-assesment/LandingPage.jsx";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export const ContactUs = () => {
  ScrollToTop();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    organization: "",
    role: "",
    message: "",
    updates: false,
  });
  const [showMemberBlockScreen, setShowMemberBlockScreen] = useState(false);
  const { setIsMyRAIsActive } = useAssessment();
  const [isMicModalActive, setIsMicModalActive] = useState(false);
  const [micModalMsg, setMicModalMsg] = useState("To chat with Myra, please grant microphone access. Your audio is processed in real-time and never stored or recorded.");
  const [access, setAccess] = useState(true);
  const history = useHistory();
  const onGrant = () => {
    setIsMicModalActive(false);
    window.isUserChatWithMyra = true;
    if (window._myraPermissionCallbacks?.onGrant) {
      window._myraPermissionCallbacks.onGrant();
    }
  };

  const oncancel = () => {
    window.isStartedLandingFlow = false;
    window.isUserChatWithMyra = false;
    setAccess(false);
    setIsMyRAIsActive(false);
    setMicModalMsg("Mic access is needed for Myra to hear your questions. If you prefer not to allow mic access, you can select the Chat option next to Talk. Or, start the Guided Self-Assessment anytime without asking Myra questions.");
    if (window._myraPermissionCallbacks?.onCancel) {
      window._myraPermissionCallbacks.onCancel();
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Connect to form backend
    alert("Form submitted! (Prototype)");
  };

  /* ===== SVG Icons ===== */
  const EmailIcon = () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  );

  const LinkedInBrandIcon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor" style={{ color: "var(--teal-brand)" }}>
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  );
  if (showMemberBlockScreen) {
    return <BrowserBlockScreen featureType="member" />;
  }

  return (
    <div className="contact-page">
      <Header setShowMemberBlockScreen={setShowMemberBlockScreen} onTryMyraClick={() => StartMyra(setIsMicModalActive, setIsMyRAIsActive)} />
      {isMicModalActive && <LandingPageModal message={micModalMsg} onGrant={onGrant} onCancel={oncancel} isMicModalActive={isMicModalActive} setIsMicModalActive={setIsMicModalActive} access={access} setAccess={setAccess} setMicModalMsg={setMicModalMsg} />}
      <section className="contact-section">
        <div className="contact-inner">
          {/* LEFT */}
          <div className="contact-info">
            <p className="section-label">Connect</p>
            <h1>Let's Build Something Better Together</h1>
            <p className="contact-info-desc">Whether you're focused on improving workplace well-being or exploring a partnership, we're here to help. Reach out and let's shape the future of recovery solutions together.</p>

            <div className="contact-detail">
              <div className="contact-detail-icon">
                <EmailIcon />
              </div>
              <Link to="mailto:info@virdiohealth.com">info@virdiohealth.com</Link>
            </div>
            <div className="contact-detail">
              <div className="contact-detail-icon">
                <LinkedInBrandIcon />
              </div>
              <a href="https://www.linkedin.com/company/virdiohealth" target="_blank" rel="noopener noreferrer">
                LinkedIn
              </a>
            </div>
          </div>

          {/* RIGHT — FORM */}
          <div className="contact-form-card">
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="fullName">Full Name</label>
                  <input type="text" id="fullName" name="fullName" placeholder="Your name" value={formData.fullName} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input type="email" id="email" name="email" placeholder="you@company.com" value={formData.email} onChange={handleChange} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="organization">Organization (optional)</label>
                  <input type="text" id="organization" name="organization" placeholder="Company name" value={formData.organization} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label htmlFor="role">Role</label>
                  <select id="role" name="role" value={formData.role} onChange={handleChange}>
                    <option value="" disabled>
                      Select one...
                    </option>
                    <option value="hr-benefits">HR / Benefits</option>
                    <option value="broker-consultant">Broker / Consultant</option>
                    <option value="health-system">Health System / Provider</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
              <div className="form-group" style={{ marginBottom: "0.75rem" }}>
                <label htmlFor="message">Message</label>
                <textarea id="message" name="message" placeholder="How can we support your goals?" value={formData.message} onChange={handleChange} />
              </div>
              <div className="checkbox-row">
                <input type="checkbox" id="updates" name="updates" checked={formData.updates} onChange={handleChange} />
                <label htmlFor="updates">I'd like to receive occasional updates from Virdio Health.</label>
              </div>
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </form>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};
